/// <reference types="fhir" />

import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

import {
  DiaprofilPatient,
  IProTask
} from "../../../app/models/diaprofil-patient";
import { DatePipe } from "@angular/common";
import { DiaprofilProTask } from "../../../app/models/diaprofil-pro-task";
import { AdminService } from "../../../app/services/admin.service";
import { ModalController } from "ionic-angular/components/modal/modal-controller";
import { NotificationLogModal } from "../../../modals/notification-log.modal/notification-log.modal";

@Component({
  selector: "pro-task-card",
  templateUrl: "./pro-task-card.component.html"
})
export class ProTaskCard implements OnInit {
  @Input() patient: DiaprofilPatient;
  @Input() proTask: DiaprofilProTask;
  @Input() proTaskType: "READY" | "DONE" = null;
  @Output() triggerDashboard = new EventEmitter();
  @Output() triggerTaskEdit = new EventEmitter();
  constructor(
    public adminService: AdminService,
    private modalCtrl: ModalController
  ) {}

  ngOnInit() {}

  onTriggerDashboard(event) {
    this.triggerDashboard.emit({ event: event, proTask: this.proTask });
  }

  onTriggerTaskEdit(event) {
    this.triggerTaskEdit.emit({ event: event, proTask: this.proTask });
  }

  triggerNotificationLogModal($event) {
    const modal = this.modalCtrl.create(
      NotificationLogModal,
      { taskId: this.proTask.task.id },
      {
        cssClass: "large-modal",
        enableBackdropDismiss: false
      }
    );
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient.page/pro-task-card.component/pro-task-card.component.ts